import Delivery from '[theme-lib]/apps/delivery/containers/Delivery';
import {
  redirectToHomepageWhenBFDisabled,
  redirectToSSOWhenUserLoggedOut,
} from './onEnterHandlers';

export default {
  path: 'delivery',
  component: Delivery,
  layoutFullWidth: true,
  onEnterHandlers: [
    redirectToHomepageWhenBFDisabled,
    redirectToSSOWhenUserLoggedOut,
  ],
};
